import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { createFetch, createSchema } from '@better-fetch/fetch';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

// types
import { APIStatusItem } from '../../utils/types';

// functions
import { API_INITIAL_STATUSES } from '../../utils/common/constants';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface HomeState {
  //
  sAPIStatuses: APIStatusItem[];
  //
} // HomeState

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: HomeState = {
  sAPIStatuses: API_INITIAL_STATUSES,
};

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const homeSlice = createSlice({
  name: 'home',
  initialState: initialState,
  reducers: {
    //
    setAPIStatuses: (state: HomeState, action: PayloadAction<APIStatusItem[]>) => {
      state.sAPIStatuses = action.payload;
    },
    //
  },
  //extraReducers: (builder) => {
  //  builder
  //    .addCase(initiateDMSearch.fulfilled, (state: FileBrowserState) => {})
  //},
});

// expose the interface.
export const { setAPIStatuses } = homeSlice.actions;
export default homeSlice.reducer;
